import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';

import { ConfiguracoesProjeto, GenericHttpService, ParametrosService } from '../../shared';

@Injectable()
export class AuthGuard implements CanActivate {
  public _dadosAutorizacaoStr: string;
  public _urlBase: string;
  public configuracao: ConfiguracoesProjeto;

  private readonly urlConsumidor: string = '/consumidor';

  constructor(
    private readonly router: Router,
    private readonly genericHttpService: GenericHttpService<Response>,
    private readonly parametrosService: ParametrosService
  ) {}

  get urlBase() {
    this.configuracao = this.parametrosService.getConfiguracao();
    this._urlBase = this.configuracao.uri + 'conta';

    return this._urlBase;
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
    this._dadosAutorizacaoStr = localStorage.getItem('authorizationData');

    if (!this._dadosAutorizacaoStr) {
      this.router.navigate([this.urlConsumidor]);
      return false;
    }

    this.genericHttpService.setApiKey(this._dadosAutorizacaoStr);

    return this.genericHttpService
      .getAll(this.urlBase + '/validar-token')
      .map((data: Response[]) => {
        if (data) {
          return true;
        }
        this.router.navigate([this.urlConsumidor]);
        return false;
      })
      .catch(erro => {
        this.router.navigate([this.urlConsumidor]);
        return of(false);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/restrito/guard/auth.guard.ts